/**
 * View component for /user-evaluations
 *
 * Generic userEvaluation list view. Defaults to 'all' with:
 * this.props.dispatch(userEvaluationActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as userEvaluationActions from '../userEvaluationActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userEvaluation components
import UserEvaluationLayout from '../components/UserEvaluationLayout.js.jsx';
import UserEvaluationListItem from '../components/UserEvaluationListItem.js.jsx';

// import userEvaluation css modules
import userEvaluationStyles from '../userEvaluationModuleStyles.css';

class UserEvaluationList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(userEvaluationActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { userEvaluationStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the userEvaluationList meta info here so we can reference 'isFetching'
    const userEvaluationList = userEvaluationStore.lists ? userEvaluationStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual userEvaluation objetcs
     */
    const userEvaluationListItems = userEvaluationStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !userEvaluationListItems || !userEvaluationList;

    return (
      <UserEvaluationLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> User Evaluation List
                <Link className="yt-btn small u-pullRight" to={'/user-evaluations/new'}> NEW User Evaluation </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (userEvaluationListItems && userEvaluationList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userEvaluationList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {userEvaluationListItems.map((userEvaluation, i) =>
                      <UserEvaluationListItem key={userEvaluation._id + i} userEvaluation={userEvaluation} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </UserEvaluationLayout>
    )
  }
}

UserEvaluationList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userEvaluationStore: store.userEvaluation
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UserEvaluationList)
);



// WEBPACK FOOTER //
// modules/userEvaluation/views/UserEvaluationList.js.jsx